import React from "react";

/**
 * Editorial split: sticky title + supporting content on the right.
 * Uses the new hairline-separated section rhythm; no panels.
 */
export function TwoCol({ label, title, lede, children, id, hairline = true, as: Heading = "h2" }) {
  return (
    <section className={`e2-shell${hairline ? " e2-section" : ""}`} data-testid={id}>
      <div className="e2-split" style={{ padding: 0 }}>
        <div className="e2-split-title-col">
          {label && <div className="e2-label e2-split-label">{label}</div>}
          <Heading className="e2-h-l">{title}</Heading>
          {lede && <p className="e2-body e2-body-lg e2-split-lede">{lede}</p>}
        </div>
        <div>{children}</div>
      </div>
    </section>
  );
}
